export const ConsumerNetIncomeSalaryUat = {
  biWeeklyLabel: 'consumerNetIncome.biWeeklyLabel',
  biWeeklyValue: 'consumerNetIncome.biWeeklyValue',
  monthlyLabel: 'consumerNetIncome.monthlyLabel',
  monthlyValue: 'consumerNetIncome.monthlyValue',
  annuallyLabel: 'consumerNetIncome.annuallyLabel',
  annuallyValue: 'consumerNetIncome.annuallyValue',
}
